import { Component, OnInit, Input } from '@angular/core';
import { TratamientoAsistencialEntity, FiltrosFormatoAsistencialEntity, FormatoAsistencialEntity, ServicioFormatoAsistencialService } from 'src/app/services/servicio-formato-asistencial.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-evolucion',
  templateUrl: './evolucion.component.html',
  styleUrls: ['./evolucion.component.css']
})
export class EvolucionComponent implements OnInit {

  @Input() tta: TratamientoAsistencialEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;
  @Input() data: FormatoAsistencialEntity;
  @Input() index: number;

  datosEvolucion: FormatoAsistencialEntity;
  filtrosEvolucion: FiltrosFormatoAsistencialEntity;
  loading: boolean;

  constructor(private servicioFormato: ServicioFormatoAsistencialService) { }

  ngOnInit() {
    this.prepareFiltros();
    this.getHeader();
  }

  prepareFiltros(){
    this.filtrosEvolucion = Object.assign({}, this.filtros);
    this.filtrosEvolucion.tta = this.tta.id;
    this.filtrosEvolucion.evoluciones = false;
  }

  async getHeader() {
    try {
      this.loading = true;
      const response = await this.servicioFormato.getHeaderFormatoAsistencial(this.filtros.codigoBaseDatos, this.tta.id);
      if(response != null) {
        response.subscribe((dataEv: FormatoAsistencialEntity) => {
          this.datosEvolucion = dataEv;
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          this.datosEvolucion = null;
          this.loading = false;
          console.error('EvolucionComponent.getHeader()', err);
        })
      }
    } catch (e) {
      this.datosEvolucion = null;
      this.loading = false;
      console.error('EvolucionComponent.getHeader()', e);
    }
  }

}
